import React from 'react';
import css from './TermsOfUseLink.css';

function TermsOfUseLink() {
  return (
      <a 
        className={css['link']} 
        href="../support/termsOfUse.html" 
        target="_blank" 
        rel="noopener noreferrer">
          Terms of Use
      </a>
  );
}

export default TermsOfUseLink;
